import React, { useState } from 'react';
import LoginForm from '../forms/LoginForm';
import styles from '../../css/components/headers/alreadyRegisteredLogin.css';
import { useTranslation } from 'react-i18next';

function AlreadyRegisteredLogin() {
	const { t } = useTranslation('translation');
	const [loginVisible, setLoginVisible] = useState(false);

	const loginWrapperClassNames = `${styles.loginWrapper} ${loginVisible ? styles.show : ''}`;

	return (
		<div>
			<button
				className={styles.alreadyRegisteredLoginWrapper}
				onClick={() => setLoginVisible(true)}
			>
				{t('loginForm.alreadyRegistered')}
			</button>
			<div
				data-testid="loginWrapper"
				className={loginWrapperClassNames}
			>
				<LoginForm />
			</div>
		</div>
	);
}

export default AlreadyRegisteredLogin;